import './RatingStars.css';

interface Props {
  value: number;
  onChange: (value: number) => void;
  size?: number;
}

// 0–5 star rating. Clicking the current rating again clears it.
export function RatingStars({ value, onChange, size = 14 }: Props) {
  return (
    <div className="stars" style={{ fontSize: size }}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          className={`stars__s ${n <= value ? 'is-on' : ''}`}
          aria-label={`${n} star${n > 1 ? 's' : ''}`}
          onClick={(e) => {
            e.stopPropagation();
            onChange(n === value ? 0 : n);
          }}
        >
          ★
        </button>
      ))}
    </div>
  );
}
